<template>
  <div>
    <div
      v-if="recentProspects.length === 0"
      class="text-center py-12 text-gray-500 dark:text-gray-400"
    >
      <p>Nog geen recente beoordelingen.</p>
    </div>

    <div v-else>
      <!-- Mobile Card View -->
      <div class="md:hidden space-y-3">
        <div
          v-for="prospect in recentProspects"
          :key="'mobile-' + prospect.id"
          class="bg-white dark:bg-gray-800 rounded-lg p-3 shadow dark:shadow-gray-900/50"
        >
          <div class="flex items-start justify-between gap-2 mb-2">
            <div class="flex-1 min-w-0">
              <div class="text-sm font-medium text-gray-900 dark:text-white truncate">
                {{ prospect.organization_name }}
              </div>
              <div class="text-xs text-gray-500 dark:text-gray-400 truncate">
                {{ prospect.subject }}
              </div>
            </div>
            <span
              :class="[
                getStatusBadgeClass(prospect.status),
                'px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap flex-shrink-0'
              ]"
            >
              {{ getStatusLabel(prospect.status) }}
            </span>
          </div>
          <div class="flex items-center justify-between text-xs text-gray-500 dark:text-gray-400">
            <span>{{ prospect.reviewed_by_name || '-' }}</span>
            <span>{{ formatDateTime(prospect.reviewed_at) }}</span>
          </div>
        </div>
      </div>

      <!-- Desktop Table View -->
      <div
        class="hidden md:block bg-white dark:bg-gray-800 shadow dark:shadow-gray-900/50 rounded-lg overflow-hidden"
      >
        <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
          <thead class="bg-gray-50 dark:bg-gray-700">
            <tr>
              <th
                class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              >
                Project
              </th>
              <th
                class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              >
                Status
              </th>
              <th
                class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              >
                Beoordeeld door
              </th>
              <th
                class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              >
                Datum
              </th>
            </tr>
          </thead>
          <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
            <tr v-for="prospect in recentProspects" :key="prospect.id">
              <td class="px-6 py-4 whitespace-nowrap">
                <div class="text-sm font-medium text-gray-900 dark:text-white">
                  {{ prospect.organization_name }}
                </div>
                <div class="text-sm text-gray-500 dark:text-gray-400">
                  {{ prospect.subject }}
                </div>
              </td>
              <td class="px-6 py-4 whitespace-nowrap">
                <span
                  :class="[
                    getStatusBadgeClass(prospect.status),
                    'px-2 py-1 text-xs font-medium rounded-full'
                  ]"
                >
                  {{ getStatusLabel(prospect.status) }}
                </span>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
                {{ prospect.reviewed_by_name || '-' }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
                {{ formatDateTime(prospect.reviewed_at) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  recentProspects: {
    type: Array,
    required: true
  },
  getStatusLabel: {
    type: Function,
    required: true
  },
  getStatusBadgeClass: {
    type: Function,
    required: true
  },
  formatDateTime: {
    type: Function,
    required: true
  }
})
</script>
